import { LazyAction, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { onItemPartContextMenu } from 'owa-mail-actions/lib/mailListSelectionActions';
import deleteConversationStoreUpdate from 'owa-mail-actions/lib/triage/deleteConversationStoreUpdate';
import deleteFolderStoreUpdate from 'owa-mail-actions/lib/triage/deleteFolderStoreUpdate';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import emptyFolderStoreUpdate from 'owa-mail-actions/lib/triage/emptyFolderStoreUpdate';
import markAllAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markAllAsReadStoreUpdate';
import markConversationsAsPinnedStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsPinnedStoreUpdate';
import markConversationsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsReadStoreUpdate';
import markItemsAsPinnedStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsPinnedStoreUpdate';
import markItemsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsReadStoreUpdate';
import { onListViewTypeOptionSaved } from 'owa-options-actions/lib/onListViewTypeOptionSaved';
import reloadTableOnTriageActionFail from 'owa-mail-actions/lib/table-loading/reloadTableOnTriageActionFail';

const lazyModule = new LazyModule(() => import(/**/ './lazyIndex'));

// Register lazy orchestrator

registerLazyOrchestrator(
    onListViewTypeOptionSaved,
    lazyModule,
    m => m.onListViewTypeOptionSavedOrchestrator
);
registerLazyOrchestrator(
    markItemsAsReadStoreUpdate,
    lazyModule,
    m => m.markItemsAsReadStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    markItemsAsPinnedStoreUpdate,
    lazyModule,
    m => m.markItemsAsPinnedStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    markConversationsAsReadStoreUpdate,
    lazyModule,
    m => m.markConversationsAsReadStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    markConversationsAsPinnedStoreUpdate,
    lazyModule,
    m => m.markConversationsAsPinnedStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    deleteItemsStoreUpdate,
    lazyModule,
    m => m.deleteItemsStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    onItemPartContextMenu,
    lazyModule,
    m => m.mailListItemExpansionOrchestrators
);
registerLazyOrchestrator(
    deleteConversationStoreUpdate,
    lazyModule,
    m => m.deleteConversationStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    deleteFolderStoreUpdate,
    lazyModule,
    m => m.deleteFolderStoreUpdateOrchestrator
);
registerLazyOrchestrator(markAllAsReadStoreUpdate, lazyModule, m => m.markAllAsReadOrchestrator);
registerLazyOrchestrator(
    emptyFolderStoreUpdate,
    lazyModule,
    m => m.emptyFolderStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    reloadTableOnTriageActionFail,
    lazyModule,
    m => m.reloadTableOnTriageActionFailOrchestrator
);
export let lazyLoadMoreInTable = new LazyAction(lazyModule, m => m.loadMoreInTable);
